<template>
  <div class="wrapper">
    <welcome
      v-if="accessEntries.length > 0"
      :user-name="user.firstName"
      :info="displayInfo"
      :display-statuses="displayStatuses"
    />
    <div v-if="showDashboard" class="section">
      <div class="assignment-section">
        <div v-if="showUserActivityLog">
          <user-activity :is-profile-listing="true" />
        </div>
        <div v-if="showAssignments">
          <assignments-listing
            :hide-headers="true"
            :hide-checkbox="true"
            :is-profile-listing="true"
            :display-columns="displayColumns"
          />
        </div>
      </div>
      <div class="placement-activity-section">
        <div>
          <dashboard />
        </div>
      </div>
    </div>
    <div v-else class="section">
      <div v-if="showAssignments">
        <assignments-listing
          :hide-headers="true"
          :hide-checkbox="true"
          :is-profile-listing="true"
          :display-columns="displayColumns"
        />
      </div>
    </div>
    <div v-if="showExecutiveDashboard" class="section">
      <div class="dash-section">
        <div class="all-branches-section">
          <dashboard />
          <span class="toggle-summaries" @click="isOpen = !isOpen">
            <font-awesome-icon :icon="isOpen ? 'sort-up' : 'sort-down'" />
            <label v-if="!isOpen"> Show Branch Summaries</label>
            <label v-else> Hide Branch Summaries</label>
          </span>
        </div>
        <executive-dashboard v-if="isOpen" />
      </div>
    </div>
  </div>
</template>

<script>
import Welcome from '../components/Welcome.vue';
import UserActivity from '@/app/features/user-activity/UserActivity.vue';
import Dashboard from '@/app/features/dashboard/Dashboard.vue';
import ExecutiveDashboard from '@/app/features/dashboard/features/ExecutiveDashboard.vue';
import AssignmentsListing from '@/app/features/assignments/features/assignments-listing/AssignmentsListing.vue';
import { ProfileGetters, ProfileActions } from '@/app/features/profile/profile-listing.keys';
import { UserActivityActions } from '@/app/features/user-activity/user-activity.keys';
import { AssignmentsListingGetters } from '@/app/features/assignments/features/assignments-listing/assignments-listing.keys';
export default {
  name: 'TesEmployeeHome',
  components: {
    Welcome,
    UserActivity,
    Dashboard,
    AssignmentsListing,
    ExecutiveDashboard
  },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isOpen: false
    };
  },
  computed: {
    displayInfo() {
      const unreadNotificationCount = this.$store.state.unreadNotificationCount;
      return {
        unreadNotificationCount,
        lastLoginAt: this.accessEntries[1] ? this.accessEntries[1].initiatedAt : '' //the second entry in list of logins is the 'last logged in'
      };
    },
    userRoles() {
      return this.$store.state.currentUser.roles.map(r => r.role_name);
    },
    accessEntries() {
      return this.$store.getters[ProfileGetters.GetRecentAccessEntries];
    },
    showDashboard() {
      return this.userRoles.some(r =>
        ['System Admin', 'Branch Admin', 'Recruiter', 'Account Manager'].includes(r)
      );
    },
    showExecutiveDashboard() {
      return this.userRoles.some(r => ['Senior Accounting', 'Executive'].includes(r));
    },
    showUserActivityLog() {
      return this.userRoles.includes('System Admin');
    },
    showAssignments() {
      return !this.userRoles.includes('System Admin');
    },
    userAssignments() {
      return this.$store.getters[AssignmentsListingGetters.AssignmentsList];
    },
    displayColumns() {
      //columns displayed for assignment list depends on the user role
      return ['branch', 'contractor', 'entity', 'client', 'startDate', 'stopDate', 'status'];
    },
    displayStatuses() {
      const roles = this.userRoles;
      let vals = [];
      if (roles.includes('Branch Admin')) {
        vals = ['Draft', 'Submitted', 'Approved', 'Rejected'];
      } else if (roles.includes('Branch Manager')) {
        vals = ['Active Online', 'Active Offline'];
      } else if (roles.includes('Recruiter') || roles.includes('Account Manager')) {
        vals = ['Active Online', 'Active Offline', 'Submitted', 'Approved', 'Rejected'];
      } else if (roles.includes('Payroll')) {
        vals = ['Submitted'];
      } else if (roles.includes('System Admin')) {
        vals = ['System'];
      }
      return vals;
    }
  },
  mounted() {
    this.$store.dispatch(
      ProfileActions.UpdateRecentAccessEntries,
      this.$store.state.currentUser.id
    );
    if (this.showUserActivityLog) {
      this.$store.dispatch(UserActivityActions.RetrieveUserActivityList);
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';

.wrapper {
  .section {
    margin-top: 25px;
    display: flex;
    flex: 1;

    .assignment-section {
      background-color: $white;
      width: 60%;
      &:not(:first-of-type) {
        margin-left: 10px;
      }
    }

    .placement-activity-section {
      background-color: $white;
      width: 40%;
      margin-left: 10px;
    }

    .dash-section {
      background-color: $white;
      width: 100%;
    }

    .all-branches-section {
      padding: 10px;
      margin: 10px;

      .toggle-summaries {
        display: inline-block;
        margin: 10px;
        padding: 10px 45px;
        label {
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
    &.dash {
      background-color: $white;
    }
  }
}
</style>
